// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".row-dados {\n  display: grid;\n  grid-template-columns: 1fr 4fr;\n}\n.row-dados img {\n  background-color: #ccc;\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  margin-right: 16px;\n}\n.row-dados div {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.row-dados div input {\n  margin-bottom: 10px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
